<template>
  <nuttrema-layout-default-slide>

    <template slot="overflow">
      <page-help
         v-if="show.pageHelp"
         file="my-preferences"
        :title="$t('label.help')"
        :anchor="`#${$route.name}`"
        @close="show.pageHelp = false">
      </page-help>
    </template>

    <nuttrema-brand-image slot="collapsed-menu-top-brand" link="professional-home"></nuttrema-brand-image>

    <template slot="collapsed-menu-top">
      <nuttrema-menu-list>
        <nuttrema-menu-list-item class="collapsed-menu-level-one">
          <sidebar-icon-level-zero></sidebar-icon-level-zero>
        </nuttrema-menu-list-item>

        <template v-if="matched('my-preferences-professional-biography')">
          <add-new-biography></add-new-biography>
        </template>
      </nuttrema-menu-list>
    </template>

    <sidebar-menu-level-zero-collapsed
      slot="collapsed-menu-level-zero"
      class="collapsed-menu-level-zero is-collapsed">
    </sidebar-menu-level-zero-collapsed>

    <sidebar-menu-my-preferences-collapsed
       slot="collapsed-menu-level-one"
       class="collapsed-menu-level-one is-collapsed"
      :meta="meta">
    </sidebar-menu-my-preferences-collapsed>

    <sidebar-menu-my-preferences-expanded
       slot="expanded-menu-level-one"
      :PersonalProfile="PersonalProfile"
      :meta="meta">
    </sidebar-menu-my-preferences-expanded>

    <template slot="sidebar-collapsed-bottom">
      <ul>
        <li>
          <sidebar-link-overlay-usermenu  icon="fas fa-th"></sidebar-link-overlay-usermenu>
        </li>
      </ul>
    </template>

  </nuttrema-layout-default-slide>
</template>


<script>
import { find } from 'lodash';

import AbstractLayoutSetDetails from 'components/ui/layout-set/abstract/abstract-layout-set-details';

import AddNewBiography from 'components/pages/professional/settings/my-preferences/professional-biography/cmpt-add-new-biography';

import SidebarMenuLevelZeroCollapsed from 'components/ui/menu/level-zero/sidebar-menu-level-zero-collapsed';

import SidebarMenuMyPreferencesExpanded from 'components/ui/menu/persons/sidebar-menu-my-preferences-expanded';
import SidebarMenuMyPreferencesCollapsed from 'components/ui/menu/persons/sidebar-menu-my-preferences-collapsed';

export default {
  name: 'layout-set-my-preferences',
  componentName: 'LayoutSetMyPreferences',
  mixins: [AbstractLayoutSetDetails],
  props: {
    meta: {
      required: true,
      default: null,
    },
  },
  components: {
    AddNewBiography,
    SidebarMenuLevelZeroCollapsed,
    SidebarMenuMyPreferencesExpanded,
    SidebarMenuMyPreferencesCollapsed,
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
  },
  methods: {
    matched(name) {
      return find(this.$route.matched, { name });
    },
    routerLink(ref, name) {
      const popover = this.$refs[ref];
      if (popover) popover.doClose();
      this.$router.replace({ name });
    },
  },
  created() {
    this.$store.dispatch('GetPersonalProfile');
    this.$on(this.EVENT.SHOW_PAGE_HELP, () => {
      this.show.pageHelp = true;
    });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearPersonalProfile');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/layout-set/persons/layout-set-my-preferences.vue